import { render, staticRenderFns } from "./NonEssentialNeedsCalculator.vue?vue&type=template&id=fdcf6054&scoped=true&"
import script from "./NonEssentialNeedsCalculator.vue?vue&type=script&lang=js&"
export * from "./NonEssentialNeedsCalculator.vue?vue&type=script&lang=js&"
import style0 from "./NonEssentialNeedsCalculator.vue?vue&type=style&index=0&id=fdcf6054&scoped=true&lang=scss&"
import style1 from "./NonEssentialNeedsCalculator.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdcf6054",
  null
  
)

export default component.exports